import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { FC } from "react";
import { SignatureType } from "../services/types";
import { getStatusDescription } from '../utils';

const useStyles = makeStyles((theme: any) => ({
  description: {
    color: theme.palette.primary.darker,
    width: 'max-content',
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
  email: {
    color: theme.palette.primary.darker,
    width: 'max-content',
    textTransform: 'capitalize',
    fontSize: "0.8rem"
  },
  date: {
    color: theme.palette.primary.darker,
    fontSize: 14,
    width: 'max-content',
  },
  item: {
    marginBottom: "1.3rem"
  }
}));

type Props = {
  signature: SignatureType
}

export const SignatureFrom: FC<Props> = ({ signature }) => {
  const classes = useStyles();
  return (
    <Box>
      {signature.signers.sort((signatureA, signatureB) => signatureA.order - signatureB.order)
        .map(({ name, email, status }, index) => (
          <Box className={signature.signers.length > 1 || signature.signers.length < index ? classes.item : ""}>
            <Typography className={classes.date}>
              {name}
            </Typography>
            <Typography className={classes.email}>
              {email}
            </Typography>
            <Typography className={classes.date}>
              {getStatusDescription(status)}
            </Typography>
          </Box>
        ))}
    </Box>
  );
};
